import { useState, useEffect } from "react";

export const SKTProgressBar = ({ label }) => {
  const [seconds, setSeconds] = useState(0);
  const isActive = true;

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 200);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const dots = [".", "..", "..."];

  return (
    <span>
      {label} {dots[seconds % dots.length]}
    </span>
  );
};
